import {useNavigate} from 'react-router';
import {type FC} from 'react';
import type {MenuItemProps, TMenuItem} from '../types';
import {getCurrentFocusKey, useFocusable} from '@noriginmedia/norigin-spatial-navigation';
import {Icon, IconWrapper, Label, LabelWrapper, MenuItemContent, MenuLink} from '../types/MenuItem.styled.ts';
import Streaming from '../../../assets/menus/streaming.svg';
import Tv from '../../../assets/menus/tv.svg';
import Replay from '../../../assets/menus/replay.svg';
import Message from '../../../assets/menus/message.svg';
import VideoCall from '../../../assets/menus/call.svg';
import Bus from '../../../assets/menus/bus.svg';

const iconMap: Record<TMenuItem['name'], string> = {
    streaming: Streaming,
    iptv: Tv,
    replay: Replay,
    message: Message,
    videoCall: VideoCall,
    amenities: Bus,
};

const MenuItem: FC<MenuItemProps> = ({item, isActive}) => {
    const icon = iconMap[item.name];
    const navigate = useNavigate();
    const deviceID = localStorage.getItem('deviceID') ?? 'test';

    const {ref, focused} = useFocusable({
        focusKey: item.name,
        onEnterPress: () => {
            navigate(`/${item.name}?deviceID=${deviceID}`);
        },
        onFocus: () => {
            ref.current?.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
            });
        },
        onArrowPress: (direction) => {
            return direction !== 'up';
        },
    });

    return (
        <MenuLink ref={ref} to={`/${item.name}?deviceID=${deviceID}`} $active={isActive} $focused={focused}>
            {/*<Icon src={icon} alt={item.name_kor} $active={isActive} $focused={focused}/>*/}
            {/*<Label $focused={focused}>{item.name_kor}</Label>*/}
            <MenuItemContent>
                <IconWrapper>
                    <Icon src={icon} alt={item.name_kor} $active={isActive} $focused={focused} />
                </IconWrapper>
                <LabelWrapper>
                    <Label $focused={focused}>{item.name_kor}</Label>
                </LabelWrapper>
            </MenuItemContent>
        </MenuLink>
    );
};

export default MenuItem;
